export function BufferViewerEleHorzPos(elementList, buffer) {
  if (!buffer) buffer = 0;
  elementList = elementList.sort(function (a, b) {
    return a.GetPositionX() - b.GetPositionX();
  });
  for (var i = 0; i < elementList.length - 1; i++) {
    var leftEle = elementList[i];
    var rightEle = elementList[i + 1];
    if (leftEle.GetWidthPositionX(buffer) > rightEle.GetPositionX())
      rightEle.SetPositionX(leftEle.GetWidthPositionX(buffer));
  }
}
